/**
 * Main App component with routing
 */

import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Layout } from './components/Layout'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Dashboard } from './pages/Dashboard'
import { ResultDetail } from './pages/ResultDetail'
import { DocumentUpload } from './pages/DocumentUpload'
import { Admin } from './pages/Admin'
import { McpSetup } from './pages/McpSetup'
import { Methodology } from './pages/Methodology'
import { Terms } from './pages/Terms'
import { Feedback } from './pages/Feedback'
import { PublicFacts } from './pages/PublicFacts'

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            {/* Dashboard handles its own auth states (login, pending, approved) */}
            <Route index element={<Dashboard />} />
            {/* Results page - shows own + public when authenticated, public only otherwise */}
            <Route path="results" element={<PublicFacts />} />
            {/* ResultDetail handles its own access control - public results viewable by anyone */}
            <Route path="results/:resultId" element={<ResultDetail />} />
            <Route
              path="upload"
              element={
                <ProtectedRoute>
                  <DocumentUpload />
                </ProtectedRoute>
              }
            />
            {/* Admin route - component checks admin status */}
            <Route
              path="admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            {/* Public explore page - no auth required */}
            <Route path="explore" element={<PublicFacts />} />
            {/* Info pages - public, no auth required */}
            <Route path="mcp-setup" element={<McpSetup />} />
            <Route path="methodology" element={<Methodology />} />
            <Route path="terms" element={<Terms />} />
            <Route path="feedback" element={<Feedback />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
